import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@tsuyosa/auth';
import { ChekiPage } from './pages/ChekiPage';
import { OrderStatusPage } from './pages/OrderStatusPage';

const API_URL = import.meta.env.VITE_API_URL ?? '';

export default function App() {
  return (
    <AuthProvider apiUrl={API_URL}>
      <BrowserRouter>
        <Routes>
          <Route path="/"          element={<ChekiPage />} />
          <Route path="/order/:id" element={<OrderStatusPage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
